'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderBenefitsWrapper = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _Slider = require('acq-components/lib/base-components/Slider/Slider');

var _ComponentHeader = require('acq-components/lib/base-components/ComponentHeader/ComponentHeader');

var _rewardsModule = require('../../utils/component-content-generation/rewardsModule');

var _benefits = require('../../redux/selectors/benefits');

var benefitsSelector = _interopRequireWildcard(_benefits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderBenefitsWrapper = function SliderBenefitsWrapper(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      shadeAlternator = _ref.shadeAlternator,
      namespace = _ref.namespace,
      isElegibilityBanner = _ref.isElegibilityBanner,
      shouldHideTitle = _ref.shouldHideTitle,
      dtmHelper = _ref.dtmHelper,
      qeId = _ref.qeId,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'shadeAlternator', 'namespace', 'isElegibilityBanner', 'shouldHideTitle', 'dtmHelper', 'qeId']);

  var shouldHaveSubTitle = !isElegibilityBanner && props.description;

  var subTitleObj = {
    Component: 'div',
    className: styles.subTitle,
    children: props.description
  };

  var items = (0, _rewardsModule.sliderRewardsModuleContent)(props.contentArray, styles, namespace, dtmHelper);

  return _react2.default.createElement(
    _FullWidthBackground.FullWidthBackground,
    {
      styles: styles.fullWidthBackground,
      isDarkShade: shadeAlternator.isShaded()
    },
    _react2.default.createElement(_ComponentHeader.ComponentHeader, {
      title: props.title,
      styles: styles,
      Component: 'h2',
      subTitle: shouldHaveSubTitle ? subTitleObj : undefined
    }),
    _react2.default.createElement(_Slider.Slider, {
      childWidth: '248px',
      childMarginRight: '20px',
      styles: styles,
      children: items,
      namespace: namespace,
      qeId: qeId
    })
  );
};

exports.SliderBenefitsWrapper = SliderBenefitsWrapper;
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var selector = benefitsSelector.getSelectors(ownProps.identifier, ownProps.isOnPage);
  return {
    title: selector.getTitle(state),
    description: selector.getDescription(state),
    contentArray: selector.getContentArray(state),
    qeId: selector.getQeId(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SliderBenefitsWrapper);